import store from 'react/redux/store/store';
import socketConnection from 'components/SocketConnection';
import { runStartup } from 'app/StartupEventManager';
import siteSocketChannels from 'session/siteSocketChannels';
import mountMatchDock from 'react/dock/mountMatchDock';

// The site session: the one Redux store and, for a logged-in user, the one
// socket connection. pages/sitePage starts it once per full page load, after
// the page area; it outlives client navigation, which only swaps
// #page_content. See docs/site-session.md.
let session = null;

export function startSiteSession(rootWindow = window) {
	if(session) {
		return session;
	}
	const user = rootWindow.myUser;
	const canConnect = !!(user && user.id && rootWindow.socketServerUrl);
	if(canConnect) {
		socketConnection.connect(siteSocketChannels());
		// The current match's bar, on every page (react/dock).
		mountMatchDock(rootWindow.document);
	}
	// Loads the user and the header's bell everywhere, plus the sections of a
	// startup page the page area set (the netplay page's chat rooms, DMs and match).
	runStartup();
	session = { store, socket: canConnect ? socketConnection : null };
	return session;
}

// The running session, or null before pages/sitePage started it.
export function getSiteSession() {
	return session;
}

// A page entry that set or changed the startup page (the netplay page coming
// in) asks for startup here. Before the session has started there is nothing
// to do: starting runs startup with the page's sections.
export function refreshStartup() {
	if(session) {
		runStartup({ force: true });
	}
}
